import classNames from "classnames";
import React from "react";
import ReactDOM from "react-dom";
import ScrollLock from "react-scrolllock";

import style from "./Modal.module.scss";

export interface ModalProps {
  isOpen: boolean;
  handleClose: () => void;
  bodyClass?: string;
  center: boolean;
}

class Modal extends React.Component<ModalProps> {
  private modalWrapperRef: React.RefObject<HTMLDivElement>;
  private modalRoot: HTMLElement | null;
  private el: HTMLDivElement;

  constructor(props: ModalProps) {
    super(props);
    this.modalRoot = document.getElementById("modalRoot");
    this.el = document.createElement("div");
    this.modalWrapperRef = React.createRef();
  }

  componentDidMount() {
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.el);
    }
  }

  handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    const { handleClose } = this.props;
    if (this.modalWrapperRef && this.modalWrapperRef.current === event.target) {
      handleClose();
    }
  };

  render() {
    const { isOpen, bodyClass, center, children } = this.props;

    return ReactDOM.createPortal(
      <div>
        {isOpen && (
          <ScrollLock>
            <div
              className={classNames(style.overlay, { [style.centered]: center })}
              ref={this.modalWrapperRef}
              onClick={this.handleClickOutside}
            >
              <div className={classNames(style.modal, bodyClass, { [style.centered]: center })}>
                <div className={style.modalInner}>{children}</div>
              </div>
            </div>
          </ScrollLock>
        )}
      </div>,
      this.el
    );
  }
}

export default Modal;
